import './LoginHeader.css'
import logoForvet from '../../../assets/RegisterPage/logoForvet_dark.svg'
import { Button, Flex} from '@mantine/core'
import { useAuth0 } from '@auth0/auth0-react';
import { useState } from 'react';
import {  IconChevronDown } from '@tabler/icons-react';
import LoginMegaMenu from '../LoginMegaMenu/LoginMegaMenu';
import useWindowDimensions from '../../../hooks/useWindowDimensions';

export default function LoginHeader({ acaUnits, officialUSD, isUSD }) {
   
   const { loginWithRedirect } = useAuth0();

   const [type, setType] = useState('')
   const [isMenu, setIsMenu] = useState(false)

   const onMouseEnter = (_type) => {
      setType(_type)
      setIsMenu(true)
   }

   const onMouseLeave = () => {
      setType('')
      setIsMenu(false)
   }

   const { width } = useWindowDimensions()
   const isMobile = width <= 768
   return (
      <header className='LoginPage-header-container'>

         <figure className='LoginPage-header--group'>
            <img
               className='LoginPage-header--logo'
               src={logoForvet}
               alt='logo FORVET'
            />
         </figure>

         <div className='LoginPage-header--loginBtn'>
            <Button size="lg" radius='xl' color='var(--color-tertiary)' onClick={() => loginWithRedirect()}>
               Ingresar
            </Button>
         </div>

        
         {!isMobile && <LoginMegaMenu
            isMenu={isMenu}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            type={type}
            acaUnits={acaUnits}
            officialUSD={officialUSD}
            isUSD={isUSD}
         />
         }
      </header>
   )
}
